"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var text_1 = __importDefault(require("relements/build/esm/input/text"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var TextLabel_1 = __importDefault(require("@src/components/TextLabel"));
var Utils = __importStar(require("@src/containers/BusinessManagerV2/utils"));
var constants_1 = require("../constants");
var GENERAL_SETTINGS = {
    title: '',
    className: 'extra-long-inputs',
    inputs: [
        {
            label: 'Business Name*',
            key: 'businessName',
            component: text_1["default"],
            props: function (data, meta, onChange) { return ({
                value: data[constants_1.INPUT_BLOCK_KEYS.BUSINESS_NAME],
                onChange: function (value) {
                    return onChange(constants_1.INPUT_BLOCK_KEYS.BUSINESS_NAME, value.trim(), false, true);
                },
                error: !data[constants_1.INPUT_BLOCK_KEYS.BUSINESS_NAME] &&
                    'Business name cannot be empty.',
            }); },
        },
        {
            label: 'Business Via Name',
            key: 'businessViaName',
            component: text_1["default"],
            props: function (data, meta, onChange) { return ({
                value: data[constants_1.INPUT_BLOCK_KEYS.BUSINESS_VIA_NAME],
                onChange: function (value) {
                    return onChange(constants_1.INPUT_BLOCK_KEYS.BUSINESS_VIA_NAME, value.trim());
                },
            }); },
        },
        {
            label: 'Account*',
            key: 'activePartners',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) {
                return {
                    options: Utils.dropdownMap(meta[constants_1.INPUT_META_KEYS.ALL_PARTNERS]),
                    optionKey: 'value',
                    searchKeys: ['value'],
                    withSearch: true,
                    value: data[constants_1.INPUT_BLOCK_KEYS.PARTNER_LIST].length === 1 &&
                        meta[constants_1.INPUT_META_KEYS.ALL_PARTNERS][data[constants_1.INPUT_BLOCK_KEYS.PARTNER_LIST]],
                    // onChange: (option: DropdownType) =>
                    //   onChange(INPUT_BLOCK_KEYS.PARTNER_LIST, [option.id], false, true),
                    error: data[constants_1.INPUT_BLOCK_KEYS.PARTNER_LIST].length === 0 &&
                        'Account cannot be empty.',
                };
            },
        },
        {
            label: 'Default Team',
            key: 'defaultTeam',
            component: dropdown_1["default"],
            props: function (data, meta, onChange) { return ({
                withSearch: true,
                options: Utils.dropdownMap(meta[constants_1.INPUT_META_KEYS.ALL_TEAMS]),
                optionKey: 'value',
                value: data[constants_1.INPUT_BLOCK_KEYS.DEFAULT_TEAM] || '',
                disabled: false,
                onChange: function (option) {
                    return onChange(constants_1.INPUT_BLOCK_KEYS.DEFAULT_TEAM, option.value);
                },
            }); },
        },
        {
            label: 'Business Languages',
            key: 'languageCode',
            component: TextLabel_1["default"],
            props: function (data, meta, onChange) {
                // Filter out the languages which are present in meta by comparing to selected languages
                var dataValues = meta.language_list.filter(function (el) {
                    return data[constants_1.INPUT_BLOCK_KEYS.LANGUAGES_SUPPORTED].some(function (code) {
                        return code === el.code;
                    });
                });
                // Get all Language names, convert to string and add spaces after commas
                var languageNames = dataValues.map(function (language) { return language.name; });
                return {
                    value: languageNames,
                    itemsToDisplay: 4,
                    tooltip: 'The languages are based on the active bot selected.',
                };
            },
        },
    ],
};
exports["default"] = GENERAL_SETTINGS;
